export var IdOutskirtBuildings;
(function (IdOutskirtBuildings) {
    IdOutskirtBuildings[IdOutskirtBuildings["Library"] = 1] = "Library";
    IdOutskirtBuildings[IdOutskirtBuildings["Market"] = 2] = "Market";
    IdOutskirtBuildings[IdOutskirtBuildings["Watertower"] = 3] = "Watertower";
    IdOutskirtBuildings[IdOutskirtBuildings["Nursery"] = 4] = "Nursery";
    IdOutskirtBuildings[IdOutskirtBuildings["Doghouse"] = 5] = "Doghouse";
    IdOutskirtBuildings[IdOutskirtBuildings["TournamentTent"] = 6] = "TournamentTent";
    IdOutskirtBuildings[IdOutskirtBuildings["Harbor"] = 9] = "Harbor";
    IdOutskirtBuildings[IdOutskirtBuildings["Cafe"] = 10] = "Cafe";
    IdOutskirtBuildings[IdOutskirtBuildings["ExternalBarn"] = 16] = "ExternalBarn";
    IdOutskirtBuildings[IdOutskirtBuildings["Pier"] = 17] = "Pier";
    IdOutskirtBuildings[IdOutskirtBuildings["ThemedEvent"] = 11] = "ThemedEvent";
})(IdOutskirtBuildings || (IdOutskirtBuildings = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdOutskirtBuildings.ts
// module id = 25
// module chunks = 3